import { allOrNoneValidator } from './all-or-none-validator';
import { atLeastOneRequiredValidator } from './at-least-one-required-validator';
import { bsnValidator } from './bsn-validator';
import { ibanValidator } from './iban-validator';
import { dateAfterValidator } from './date-after-validator';
import { dateBeforeValidator } from './date-before-validator';
import { e164Validator } from './e164-validator';
import { fileTypeValidator } from './file-type-validator';
import { maxDateValidator } from './maximum-date-validator';
import { minDateValidator } from './minimum-date-validator';
import { minimumAgeValidator } from './minimal-age-validator';
import { passwordValidator } from './password-validator';
import { numberValidator } from './number-validator';
import { endTimeAfterStartTimeValidator } from './end-time-after-start-time-validator';

export const ilionxValidators = {
  allOrNone: allOrNoneValidator,
  atLeastOneRequired: atLeastOneRequiredValidator,
  bsn: bsnValidator,
  iban: ibanValidator,
  dateAfter: dateAfterValidator,
  dateBefore: dateBeforeValidator,
  e164: e164Validator,
  fileType: fileTypeValidator,
  maxDate: maxDateValidator,
  minDate: minDateValidator,
  minimumAge: minimumAgeValidator,
  password: passwordValidator,
  number: numberValidator,
  endTimeAfterStartTime: endTimeAfterStartTimeValidator,
};
